import { render } from "./splash.vue?vue&type=template&id=5096ff87&scoped=true"
import script from "./splash.vue?vue&type=script&lang=js"
export * from "./splash.vue?vue&type=script&lang=js"

import "./splash.vue?vue&type=style&index=0&id=5096ff87&scoped=true&lang=scss"

import exportComponent from "/Applications/MAMP/htdocs/funfindhk20250610/front-vue-src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5096ff87"]])

export default __exports__